import TransferTrapsPopover from './TransferTrapsPopover'
import enhance from './TransferTrapsPopover.enhancer'

export default enhance(TransferTrapsPopover)



// WEBPACK FOOTER //
// ./src/components/organisms/TransferTrapsPopover/index.js